import { Component } from 'react';
import { SliderComponent } from '@/shared/scripts/components/slider/slider.component';
import { cockpit } from '@/shared/scripts/shared/models/cockpit.model';
import { createRoot } from 'react-dom/client';
import './welcome.component.scss';

export class WelcomeComponent extends Component<any, any> {
  render() {
    const images = cockpit?.home_welcome_images.map((i: CustomizeImage) => i.image.url);

    return <SliderComponent images={images} />;
  }
}

const selector = document.getElementById('welcome-slider');
const isInIframe = window.self !== window.top;
if (selector && !isInIframe) {
  const root = createRoot(selector);
  root.render(<WelcomeComponent />);
}
